import { Element } from "@xmpp/xml"
import { Car } from "@/reducers/carsSlice"
import CarsParser, { CARS_NODE } from "@/lib/carsParser"

type CarPubSubEvent = {
  type: "create" | "retract"
  car: Car | { id: string }
}

export default class CarPubSubEventParser {
  static parse = (stanza: Element): CarPubSubEvent | undefined => {
    const node = stanza.getChild("event")?.getChildByAttr("node", CARS_NODE)

    if (!node) return

    if (node.getChild("item")) {
      return {
        type: "create",
        car: CarsParser.parseItem(node.getChild("item")!),
      }
    } else if (node.getChild("retract")) {
      return {
        type: "retract",
        car: { id: node.getChild("retract")?.getAttr("id") as string },
      }
    }
  }
}
